import { render, staticRenderFns } from "./PickupPoints.vue?vue&type=template&id=b662bb06&scoped=true&"
import script from "./PickupPoints.vue?vue&type=script&lang=ts&"
export * from "./PickupPoints.vue?vue&type=script&lang=ts&"
import style0 from "./PickupPoints.vue?vue&type=style&index=0&id=b662bb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662bb06",
  null
  
)

export default component.exports